export default __webpack_public_path__ + "static/media/perform-outline-16px.ab52d88e.svg";